export class ActionsKeys {
    public static PlanGroupsListActions: string = "PlanGroupsQueue.PlanGroupsListActions";
    public static PlanGroupsQueueDialogActions: string = "PlanGroupsQueue.PlanGroupsQueueDialogActions";
}

export class ActionCreatorKeys {
    public static PlanGroupsListActionsCreator: string = "ACTION_CREATOR_KEY_PLAN_GROUPS_LIST_ACTIONS_CREATOR";
    public static PlanGroupsQueueDialogActionsCreator: string = "ACTION_CREATOR_KEY_PLAN_GROUPS_QUEUE_DIALOG_ACTIONS_CREATOR";
}

export class StoreKeys {
    public static PlanGroupsListStore: string = "STORE_KEY_PLAN_GROUPS_LIST_STORE";
    public static PlanGroupsQueueDialogStore: string = "STORE_KEY_PLAN_GROUPS_QUEUE_DIALOG_STORE";
}